<mat-sidenav-container style="height:100%">

  <mat-sidenav mode="side" opened [style.width.px]="menuResizer.menuWidth">
    <ng-content select="[left]"></ng-content>
  </mat-sidenav>

  <mat-sidenav-content [style.width.px]="sideNavContentSize" style="float: right;">
    <div style="flex: 0 0 5px;" class="sidenav-grip-handle" (mousedown)="menuResizer.onMenuResize($event)"></div>
    <ng-content select="[right]"></ng-content>
  </mat-sidenav-content>

</mat-sidenav-container>
